import React from 'react';
import { Workflow, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from './ui/dropdown-menu';
import { MERMAID_TEMPLATES } from '../utils/mermaidTemplates';

// "Insert diagram" dropdown shown in both Visual and Markdown editor modes.
// Calls onInsert(template) with the chosen template.
export function InsertDiagramMenu({ onInsert }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="outline" size="sm" data-testid="insert-diagram-btn">
          <Workflow className="mr-2 h-4 w-4" />
          Insert diagram
          <ChevronDown className="ml-1 h-3.5 w-3.5 opacity-70" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-48">
        <DropdownMenuLabel>Diagram type</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {MERMAID_TEMPLATES.map((tpl) => (
          <DropdownMenuItem
            key={tpl.key}
            onSelect={() => onInsert(tpl)}
            data-testid={`insert-diagram-${tpl.key}`}
          >
            {tpl.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
